export default __webpack_public_path__ + "static/1-7f6d0cb7e199bd6940832d09f4c83990.png";